import React from 'react';
import { cn } from '../../lib/cn';
import { Icon } from '../Icon/Icon';

export interface CheckboxProps {
  label?: React.ReactNode;
  checked?: boolean;
  defaultChecked?: boolean;
  onChange?: (checked: boolean) => void;
  onCheckedChange?: (checked: boolean) => void;
  disabled?: boolean;
  indeterminate?: boolean;
  size?: 'sm' | 'md' | 'lg';
  description?: React.ReactNode;
}

export function Checkbox({ label, checked, disabled, indeterminate, onChange }: CheckboxProps) {
  return (
    <label className="inline-flex cursor-pointer items-center gap-2.5 text-sm text-[var(--ink-1)]">
      <span onClick={() => !disabled && onChange?.(!checked)} className={cn('flex h-5 w-5 shrink-0 items-center justify-center rounded-md border-[1.5px] transition', checked || indeterminate ? 'border-[var(--sage-0)] bg-[var(--sage-0)] text-white' : 'border-[var(--cream-shadow)] bg-[var(--cream-1)]', disabled && 'opacity-40')}>
        {indeterminate ? <Icon kind="minus" size={13} stroke={3} /> : checked ? <Icon kind="check" size={13} stroke={3} /> : null}
      </span>
      {label}
    </label>
  );
}
